export enum TransactionType {
  Claim = 1,
  Dispute = 2,
}

export enum TransactionTypeCode {
  CL = 1,
  CS = 2,
}

// eslint-disable-next-line func-style
export function transactionTypeNameFromTransactionType(transactionType: TransactionType) {
  const name = TransactionType[transactionType];

  return name;
}
